export default __webpack_public_path__ + "static/media/services-cut.cf31bf79.svg";